import { render, staticRenderFns } from "./CustomerTransaction.vue?vue&type=template&id=348bc240&scoped=true&"
import script from "./CustomerTransaction.vue?vue&type=script&lang=js&"
export * from "./CustomerTransaction.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransaction.vue?vue&type=style&index=0&id=348bc240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348bc240",
  null
  
)

export default component.exports